import * as angular from "angular";
import {IController} from "angular";
import {AgentModel} from "../../angular/models/agent.model";

export class AgentAssignSwapTableRowCtrl implements IController {

  agent: AgentModel;
  score: any;
  isIgnoreScore: boolean;

  onAssign: Function;
}

angular
  .module('bringoz.admin.agents')
  .component('agentAssignSwapTableRow', {
    bindings: {
      agent : '<',
      score: '<',
      isIgnoreScore: '<?',
      onAssign : '&'
    },
    template: require('./agent-assign-swap-table-row.html').default,
    controller: AgentAssignSwapTableRowCtrl
  });
